<template>
  <div>
    <div class="text-center mt-2">
      <img width="62px" src="@/assets/logo.png" />
    </div>

    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      คะแนนสะสม
    </div>
    <div v-if="$store.state.redirectview">
      <v-btn
        @click="query.view = $store.state.redirectview"
        text
        color="primary"
      >
        <v-icon>mdi-chevron-left</v-icon>
        กลับ
      </v-btn>
    </div>
    <div class="pa-3">
      <v-layout wrap>
        <v-flex xs6 class="pr-1">
          <v-btn
            rounded
            :outlined="currentTab != 'pointHistory'"
            :color="currentTab == 'pointHistory' ? 'primary' : ''"
            @click="currentTab = 'pointHistory'"
            class="ma-0 mr-1 mb-1"
            block
            style="font-size: 12px"
            >ประวัติสะสมคะแนน</v-btn
          ></v-flex
        >
        <v-flex xs6 class="pl-1">
          <v-btn
            block
            rounded
            :outlined="currentTab != 'pointLog'"
            :color="currentTab == 'pointLog' ? 'primary' : ''"
            @click="currentTab = 'pointLog'"
            class="ma-0 mr-1 mb-1"
            style="font-size: 12px"
          >
            รายการเดินคะแนนสะสม
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="loading" class="text-center mt-7">
      <v-progress-circular indeterminate color="primary" size="60">
      </v-progress-circular>
    </div>
    <div v-else class="px-3">
      <template v-if="currentTab === 'pointHistory'">
        <div class="text-right">
          <v-pagination
            v-if="pagelength > 1"
            :total-visible="4"
            v-model="pageNumber"
            @input="changePage"
            :length="pagelength"
          ></v-pagination>
        </div>
        <v-card v-if="historydata.length" class="elevation-5 mt-4">
          <div
            style="position: relative"
            v-for="(item, k) in historydata"
            :key="k"
            class="pa-2"
          >
            <div
              style="font-size: 12px; position: absolute; right: 4px; top: 3px"
            >
              {{ moment(item.timestamp).format("DD/MM/YYYY HH:mm") }}
            </div>
            <div class="px-3 py-3">
              <v-row dense>
                <v-col cols="3">ห้าง</v-col>
                <v-col cols="7"
                  >{{ item.department_store }} สาขา {{ item.branch }}</v-col
                >
                <v-col cols="3">เลขที่ Ref</v-col>
                <v-col cols="7">{{ item.ref_no }}</v-col>
                <v-col cols="3">สถานะ</v-col>
                <v-col cols="7" :style="{ color: statuscustom(item).color }">
                  <span v-if="statuscustom(item).text == 'อนุมัติ'">
                    ได้รับ {{ item.total_points }} คะแนน
                  </span>
                  <span v-else>{{ statuscustom(item).text }}</span>
                </v-col>
                <template v-if="item.status == 'reject'">
                  <v-col cols="3">สาเหตุ</v-col>
                  <v-col cols="7">{{
                    item.admin_status_option ===
                    "ยกเลิกรายการ เนื่องจากไม่ทำรายการภายในเวลาที่กำหนด"
                      ? item.admin_status_option
                      : item.remark
                  }}</v-col>
                </template>
              </v-row>
              <div v-if="item.status == 'reject'" class="text-center">
                <v-btn
                  @click="
                    editdata = item;
                    showCollectEdit = true;
                  "
                  :disabled="
                    item.admin_status_option ===
                      'ยกเลิกรายการ เนื่องจากไม่ทำรายการภายในเวลาที่กำหนด'
                  "
                  class="px-4 primary--text"
                  depressed
                  color="#eee"
                  small
                  ><v-icon color="primary">mdi-square-edit-outline</v-icon
                  >แก้ไข</v-btn
                >
              </div>
            </div>
            <v-divider v-if="k < historydata.length - 1"></v-divider>
          </div>
        </v-card>
        <div
          v-else
          style="color: darkgrey; font-size: 24px"
          class="mt-7 text-center"
        >
          ยังไม่ประวัติการแนบใบเสร็จ
        </div>
      </template>
      <template v-else-if="currentTab === 'pointLog'">
        <PointLog v-if="currentTab === 'pointLog'" />
      </template>
    </div>
    <v-dialog v-model="showCollectEdit">
      <v-card class="pb-10">
        <div v-if="showCollectEdit">
          <div class="text-right">
            <v-btn @click="showCollectEdit = false" icon color="primary">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <Collect
            class="Kanit"
            :edittype="'edit'"
            :editdata="editdata"
            @success="handleEditSuccess"
          ></Collect>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Collect from "@/views/PointManager/Collect.vue";
import PointLog from "./PointLog.vue";

export default {
  data() {
    return {
      editdata: "",
      showCollectEdit: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      status: "",
      historydata: [],
      currentTab: "pointHistory",
    };
  },
  components: {
    Collect,
    PointLog,
  },
  mounted() {
    this.getData();
  },
  computed: {
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10);
      } else {
        return 1;
      }
    },
    moment() {
      return moment;
    },
  },
  methods: {
    changePage(val) {
      var vm = this;
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val;
        vm.offset = vm.pageNumber * this.limit - this.limit;
        if (vm.pageNumber != 1) {
          vm.offset + 1;
        }
        this.getData();
      }
    },
    statuscustom(item) {
      if (item.status == "approved") {
        if (
          item.accounting_status == "approved" &&
          item.manager_status == "approved"
        ) {
          return { text: "อนุมัติ", color: "green" };
        } else {
          return { text: "รออนุมัติ", color: "orange" };
        }
      } else if (item.status == "waiting") {
        return { text: "รอดำเนินการ", color: "grey" };
      } else if (item.status == "pending") {
        return { text: "รออนุมัติ", color: "orange" };
      } else if (item.status == "reject") {
        return { text: "รายการไม่ถูกต้อง", color: "red" };
      } else {
        return { text: status, color: "grey" };
      }
    },
    getData() {
      return new Promise((resolve) => {
        var data = {
          memberId: this.$store.state.member.memberId, // required
          limit: this.limit,
          offset: this.offset,
          pageid: this.query.pageid,
        };
        this.loading = true;
        axios
          .get(this.serverUrl + "toacrm/history-reward-points", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then((response) => {
            this.loading = false;
            if (response.data.responsecode == 200) {
              this.total = response.data.total;
              this.historydata = response.data.data.map((el) => {
                try {
                  var productdetail = JSON.parse(el.productdetail);
                } catch (error) {
                  var productdetail = {};
                }
                try {
                  var nameaddress = JSON.parse(el.nameaddress);
                } catch (error) {
                  var nameaddress = {};
                }
                return {
                  ...el,
                  productdetail,
                  nameaddress,
                };
              });
            }
          });
      });
    },
    async handleEditSuccess() {
      await this.$store.dispatch("sendMessage", "อัปโหลดใบเสร็จสำเร็จ");
    },
  },
};
</script>

<style lang="scss" scoped></style>
